import { isAxiosError } from 'axios';
import { Result, err, ok } from 'neverthrow';

// eslint-disable-next-line @typescript-eslint/ban-ts-comment
// @ts-ignore utils is in the parent dir
import axios from '@utils/axios';

import { QuoteCountries } from 'pages/QuoteView/Quoting/RequestQuickQuote/types';
import { ApiError } from 'types/api/ApiError';
import captureException from 'utils/captureException';

export type LocationSuggestion = {
  placeId: number;
  city: string;
  state: string;
  postalCode: string;
  country: QuoteCountries;
  displayLabel: string;
  isFsa: boolean;
};

type LocationSuggestionsResponse = {
  suggestions: LocationSuggestion[];
};

export async function getLocationSuggestions(
  query: string,
  limit = 8
): Promise<Result<LocationSuggestionsResponse, ApiError>> {
  try {
    const response = await axios.get<LocationSuggestionsResponse>(
      '/locations/suggest',
      {
        params: { q: query, limit },
      }
    );
    return ok(response.data);
  } catch (error) {
    captureException(error, { functionName: 'getLocationSuggestions' });

    return err({
      message: isAxiosError(error)
        ? error.response?.data?.message || 'Failed to suggest locations'
        : 'Failed to suggest locations',
      status: isAxiosError(error) ? error.response?.status : undefined,
    });
  }
}
